module.exports = __webpack_public_path__ + "static/media/6.314da653.png";